export const systemAssignmentsState = {
    name: 'app.system.assignments',
    url: '/assignments',
    component: 'system'
};
